import { WalmartLandingPage } from 'pages/loyalty/loyalty-partners/walmart';
import { useWalmartDisabledPage } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';

export default function WalmartPlusRoute() {
  const disabledRedirect = useWalmartDisabledPage();
  if (disabledRedirect) {
    return disabledRedirect;
  }

  return <WalmartLandingPage />;
}
